import * as Headless from '@headlessui/react'
import clsx from 'clsx'

const colors = {
  'dark/zinc': 'bg-zinc-900',
  dark: 'bg-zinc-900',
  zinc: 'bg-zinc-600',
  blue: 'bg-blue-600',
  emerald: 'bg-emerald-600',
  green: 'bg-green-600',
  red: 'bg-red-600',
  rose: 'bg-rose-500',
  amber: 'bg-amber-400',
  orange: 'bg-orange-500',
  cyan: 'bg-cyan-300',
  indigo: 'bg-indigo-600',
  sky: 'bg-sky-500',
}

export function SwitchGroup({ className, ...props }) {
  return <div {...props} className={clsx('space-y-4', className)} />
}

export function SwitchField({ className, ...props }) {
  return <Headless.Field {...props} className={clsx('flex items-start justify-between gap-4', className)} />
}

export function Switch({ color = 'dark/zinc', checked, className, ...props }) {
  return (
    <Headless.Switch
      checked={checked}
      {...props}
      className={clsx(
        'relative inline-flex h-6 w-10 shrink-0 cursor-pointer rounded-full p-1 ring-1 ring-inset transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
        checked ? colors[color] || colors['dark/zinc'] : 'bg-zinc-200 ring-zinc-900/10',
        className
      )}
    >
      <span
        aria-hidden="true"
        className={clsx(
          'pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow transition-transform',
          checked ? 'translate-x-4' : 'translate-x-0'
        )}
      />
    </Headless.Switch>
  )
}
